module.exports = __webpack_public_path__ + "img/know-3.07d18e2a.gif";